import classnames from 'classnames'
import { FieldValidator } from 'final-form'
import React, { useCallback, useRef } from 'react'
import { Field } from 'react-final-form'
import { useIntl } from 'react-intl'
import { defaultProps } from 'react-select/src/Select'

import styles from './Input.module.css'

interface IInputProps {
  label?: string
  className?: string
  name: string
  placeholder?: string
  optional?: boolean
  ariaDescription?: string
  type?: 'date' | 'text' | 'number'
  disabled?: boolean,
  hidden?: boolean,
  maxLength?: number,
  max?: number,
  min?: number,
  dependantValue?: any,
  validate?: FieldValidator<string>
  onBlur?: (event: React.FocusEvent<HTMLElement> | undefined) => void
}

export const Input: React.FC<IInputProps> = ({
  type = 'text',
  disabled = false,
  hidden = false,
  optional = false,
  name,
  label,
  max,
  min,
  placeholder,
  ariaDescription,
  className = '',
  validate = undefined,
  onBlur = _ => {},
  maxLength,
}) => {

  const requiredValidation = useCallback((value: string, _allValues: any) => {
    if (!optional && (value == null || value === '')) {
      return 'Obavezno polje'
    } else {
      return undefined
    }
  }, [ optional])

  const validatorRef = useRef<FieldValidator<string>>((value: string, allValues: any) => {
    const validations: Array<FieldValidator<string>> = []

    if (!optional) {
      validations.push(requiredValidation)
    }
    if (validate != null) {
      validations.push(validate)
    }

    return validations.reduce((message: string | undefined, fn) => (
      message == null
        ? fn(value, allValues)
        : message
      ), undefined)
  })

  return (
    <Field
      name={name}
      validate={validatorRef.current}
    >
      {({ input, meta }) => (
        <div className={classnames(styles.Input, className)}>
          { label && !hidden && <label htmlFor={name}>{optional ? label : label + " *"}</label> }
          <input
            className={classnames({ 'form-control': true, 'is-invalid': meta.touched && meta.error })}
            type={type}
            {...input}
            placeholder={placeholder}
            aria-describedby={ariaDescription}
            disabled={disabled}
            hidden={hidden}
            min={min}
            max={max}
            onChange={event => {
              document.querySelectorAll('input[name=' + event.target.name + ']')
                ?.forEach(element => (element as HTMLInputElement).setCustomValidity(""));
              input.onChange(event);
            }}
            onInvalid={event => (event.target as HTMLSelectElement).setCustomValidity('Molimo upisati ispravan datum rođenja.')}
            maxLength={maxLength}
            onBlur={(value: React.FocusEvent<HTMLElement> | undefined) => {
              input.onBlur(value);
              if (onBlur !== undefined) {
                onBlur(value);
              }
              if (name === 'txtIznos1' || name === 'txtIznos2' || name === 'txtIznos3') {
                let tempValue = parseFloat((value?.target as HTMLInputElement).value);
                if (!isNaN(tempValue)) {
                  let valueNumber = new Intl.NumberFormat('de-DE',  {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(tempValue);
                  (value?.target as HTMLInputElement).value = valueNumber;
                  input.onChange(value)
                } else if (isNaN(tempValue)) {
                  (value?.target as HTMLInputElement).value = '';
                  input.onChange(value)
                }
              }
            }}
          />
          { meta.touched && meta.error && <div className='invalid-feedback'>{meta.error} '{label?.replace(":", "")}'</div> }
          { ariaDescription && (
            <span
              id={`help-${name}`}
              className={classnames('form-text text-muted', styles.AriaDescription)}
            >
              { ariaDescription }
            </span>
          ) }
        </div>
      )}
    </Field>
  )
}